import React from 'react'

function TenderTextWall() {
  return (
    <embed src="\pdfs\EAT1.4.5_Q-W__Wall_displacement_outlet_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextWall